export const PATH_DAY_PLAN_INDEX = '/meals/day-plan';
export const PATH_DAY_PLAN_INDEX_WITH_DATE = `/:date`;
export const PATH_DAY_PLAN_MEAL_DETAILS = `/:date/:dietMealId/:mealType/:userDietSetId/:originalMealId`;
export const PATH_DAY_PLAN_REPLACE_MEAL = `/:date/:dietMealId/:mealType/:userDietSetId/:originalMealId/replace`;
export const PATH_DAY_PLAN_REPLACE_DAY = `/:date/change`;
export const PATH_FAV_MEALS = '/module/favourite-meals/*';
export const PATH_FAV_MEAL_DETAILS = '/module/favourite-meals/:mealId';
export const PATH_SHOPPING_LIST = '/module/shopping-list';
